import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

const tabs = ['幼稚園／幼兒園', '小學'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="weather-information">
        <h1>天氣資訊</h1>
        <p>
          京斯敦國際學校會根據教育局為小學在颱風或持續大雨時發出的指示，而作出相應安排。請瀏覽
          <a href="http://www.edb.gov.hk" target="_blank" rel="noopener noreferrer">
            教育局網站
          </a>
          以獲得更多有關學校在惡劣天氣下停課的最新資訊。學校會通過電郵通知家長有關學校停課的安排。
        </p>

        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <h3>颱風信號</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>一號風球</td>
                  <td>除非另行通知，否則學校照常上課</td>
                </tr>
                <tr>
                  <td>三號風球</td>
                  <td>停課</td>
                </tr>
                <tr>
                  <td>八號風球或以上</td>
                  <td>停課</td>
                </tr>
                <tr>
                  <td>當天文台以三號取代八號或以上熱帶氣旋警告信號</td>
                  <td>停課</td>
                </tr>
                <tr>
                  <td>當天文台以一號取代三號熱帶氣旋警告信號或取消所有熱帶氣旋警告信號</td>
                  <td>除非事前已公佈所有學校須全日停課，否則學校應恢復上課 (在當日的下午或 翌日的上午 ）</td>
                </tr>
              </tbody>
            </table>

            <h3>暴雨警告信號</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>黃色暴雨警告信號</td>
                  <td>學校照常上課</td>
                </tr>
                <tr>
                  <td>紅色或黑色暴雨警告信號</td>
                  <td>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>在上午 5 時 3 0 分 至 8 時 前發 出</strong>
                      <br />上午校停課
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>在 上 午 1 0 時 3 0 分至下午1 時前發出</strong>
                      <br />上午校繼續上課 ，並須在安全情況下，方可讓學生回家 。
                      <br />下午校停課
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>在下午1時或以後發出</strong>
                      <br />學校繼續上課，並須在安全情況下，方可讓學生回家
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}

        {tab === 1 && (
          <React.Fragment>
            <h3>颱風信號</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>一號風球</td>
                  <td>照常上課</td>
                </tr>
                <tr>
                  <td>三號風球</td>
                  <td>
                    照常上課(若教育局宣布全日制學校停課，則該天停課一天，請家長留意電台及電視廣播)或查詢
                    <a href="http://www.edb.gov.hk" target="_blank" rel="noopener noreferrer">
                      教育局網站
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>八號風球或以上</td>
                  <td>停課</td>
                </tr>
              </tbody>
            </table>

            <h3>暴雨警告信號</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>黃色暴雨警告信號</td>
                  <td>School operates as normal</td>
                </tr>
                <tr>
                  <td>紅色暴雨警告信號</td>
                  <td>如信號在上午八時前發出，該天停課</td>
                </tr>
                <tr>
                  <td>黑色暴雨警告信號</td>
                  <td>如信號在上午八時前發出，該天停課</td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}

        <p>
          假若在上課時間內懸掛八號風球或黑雨信號，學校會繼續開放。但請家長盡快到學校接　貴
          子弟回家。在惡劣天氣情況下，家長如住在偏遠地方或路面情況混亂，家長可自行決定是否讓　貴子弟上學。
        </p>
        <p>請注意，若黑色暴雨警告訊號生效，所有乘搭校車放學的學生不會如常放學。家長應知會校車公司以作出相應安排。</p>
      </ContentLayout>
    );
  }
}
